import React from 'react';
import axios from 'axios';
import { useParams, useNavigate } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import { Loader, Text, Button, Container, Group, Box } from '@mantine/core';
import { v4 as uuidv4 } from 'uuid';
import { IconCircleCheck, IconCircleX } from '@tabler/icons-react';

import { utils, brand, BE_API_SU_ONE } from "../../utils/globalVariables";
import { regexLimitChar } from "../../utils/globalFunctions";

const ForgotPasswordSecondStepSU = () => {

    const mountedRef = React.useRef(true);
    const parameter = useParams();
    const navigate = useNavigate();

    const notificationId = React.useRef({
        errorSubmitData: 'ForgotPasswordSecondStepSU-1',
    })

    const [data, setData] = React.useState({
        dataInitLoading: false,
        res: ''
    });

    React.useEffect(() => {
        document.title = "Verification Link " + brand.longName;

        return () => {
            mountedRef.current = false;
        }
    }, []);

    React.useEffect(() => {
        /*
        info : Jika email username dan password yg baru terkirim dua kali, kemungkinan besar itu disebabkan karena behavior react strict mode di development mode. React versi ini mempunyai behavior render dua kali saat strict mode di development mode.
        */

        setData(d => ({ ...d, dataInitLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('v_link', parameter.kode ? parameter.kode : null);
        formDT.append('username', regexLimitChar(uuidv4(), utils.generateUsernameLength));
        formDT.append('password', regexLimitChar(uuidv4(), utils.generatePasswordLength));
        formDT.append('nama_perusahaan', brand.longName);

        axios({
            method: 'post',
            url: BE_API_SU_ONE + '/verification_link_super_user',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, dataInitLoading: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({
                    ...d,
                    res: 'success'
                }));
            }

            if (response.data.flag_status === 'invalid-v-link') {
                setData(d => ({
                    ...d,
                    res: 'invalid-v-link'
                }));
            }

            if (response.data.flag_status === 'email-not-sent') {
                setData(d => ({
                    ...d,
                    res: 'email-not-sent'
                }));
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, dataInitLoading: false, res: '' }));

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }, [parameter.kode]);

    return (
        <Container
            my='5rem'
        >
            <Text
                ta='center'
                size='32px'
                fw='500'
                mb='2rem'
            >
                {brand.appName} Verifikasi
            </Text>

            {data.dataInitLoading &&
                <Box ta='center'>
                    <Text
                        size='18px'
                        color="dimmed"
                        ta="center"
                        mb='1rem'
                    >
                        Harap Menunggu..
                    </Text>

                    <Text
                        color="dimmed"
                        ta="center"
                        mb='1rem'
                    >
                        Proses verifikasi tautan dan reset mungkin membutuhkan beberapa waktu untuk mengirim email.
                    </Text>

                    <Loader
                        variant="bars"
                    />
                </Box>
            }

            {!data.dataInitLoading && data.res === 'success' &&
                <Box ta='center'>
                    <IconCircleCheck
                        size={48}
                        strokeWidth={2}
                        color='gray'
                    />

                    <Text
                        color="dimmed"
                        ta="center"
                        mt='.5rem'
                        mb='2rem'
                    >
                        Username dan password baru telah dikirim ke alamat email Anda. <br />
                        Segera periksa email Anda pada inbox atau spam.
                    </Text>

                    <Group position="center">
                        <Button
                            variant="light"
                            onClick={() => {
                                navigate('/superuser', { replace: true });
                            }}
                        >
                            Ke Halaman Login
                        </Button>
                    </Group>
                </Box>
            }

            {!data.dataInitLoading && data.res === 'email-not-sent' &&
                <Box ta='center'>
                    <IconCircleX
                        size={48}
                        strokeWidth={2}
                        color='gray'
                    />

                    <Text
                        color="dimmed"
                        ta="center"
                        mt='.5rem'
                        mb='2rem'
                    >
                        Email tidak terkirim. Silahkan ulangi proses.
                    </Text>

                    <Group position="center">
                        <Button
                            variant="light"
                            onClick={() => {
                                navigate('/superuser', { replace: true });
                            }}
                        >
                            Ke Halaman Login
                        </Button>
                    </Group>
                </Box>
            }

            {!data.dataInitLoading && data.res === 'invalid-v-link' &&
                <Box ta='center'>
                    <IconCircleX
                        size={48}
                        strokeWidth={2}
                        color='gray'
                    />

                    <Text
                        color="dimmed"
                        ta="center"
                        mt='.5rem'
                        mb='2rem'
                    >
                        Link expired atau tidak valid.
                    </Text>

                    <Group position="center">
                        <Button
                            variant="light"
                            onClick={() => {
                                navigate('/superuser', { replace: true });
                            }}
                        >
                            Ke Halaman Login
                        </Button>
                    </Group>
                </Box>
            }
        </Container>
    )
}

export default ForgotPasswordSecondStepSU;